<template>
    <div
        class="d-flex flex-nowrap gap-2"
        @dblclick="editTime"
    >
        <DateComp
            :value="value"
            format="DATETIMEMS3"
        />
        <ButtonComp
            class="btn-sm"
            buttonType="Edit"
            @click="editTime"
        />
    </div>
</template>

<script setup lang="ts">
import { DateComp, ButtonComp, AddEditTime } from '@/components';
import { AddEditTimeRequest } from '../Time/AddEditTimeRequest';
import type { ContestantAndRaceContestantTime } from '@/objects/generated';
import { useDialogBuilder } from '@/composeables/dialog/dialogbuilder';
import { ref } from 'vue';

const props = defineProps<{
    value: Date | null;

    row: ContestantAndRaceContestantTime;

    // A callback for when the save button is clicked
    saveCallback?: (request: AddEditTimeRequest) => void;
}>();

const editTime = () => {
    const request = ref(
        new AddEditTimeRequest({
            time: props.row.Time,
            raceContestantId: props.row.RaceContestantID,
            stationId: props.row.StationID,
            tuid: props.row.TUID,
        }),
    );

    // TODO: Use globaldialog OpenAddTimeModal (when that has support for selecting the station ID)
    useDialogBuilder()
        .withTitle('contestanttime.edittime')
        .withBodyComponent(AddEditTime, {
            vmodel: request,
        })
        .withCancelButton({
            action: () => {},
        })
        .withSaveButton({
            action: async () => {
                if (props.saveCallback) {
                    props.saveCallback(request.value);
                }
                return true;
            },
        })
        .withOptions({
            Size: 'md',
        })
        .Open();
};
</script>
